import React from "react"
import "./style.scss"

const Policy = ({ sectionData }) => {
  const {
    title,
    // policyOneTitle,
    // policyOneContent,
    image,
    policies,
  } = sectionData
  return (
    <div className="privacy-policy">
      <div className="top__area">
        <div>
          <h1>{title}</h1>
        </div>
        <div>
          <img src={image} alt="policy" />
        </div>
      </div>
      <div className="content">
        {/* <div className="policy-item">
          <h1 className="header">{policyOneTitle}</h1>
          <ul>
            {policyOneContent &&
              policyOneContent.map((item, index) => {
                return (
                  <li key={index}>
                    <p className="text">{item.content}</p>
                  </li>
                )
              })}
          </ul>
        </div> */}
        {policies &&
          policies.map((policy, idx) => (
            <div key={idx} className="policy-item">
              <h1 className="header">{policy.title}</h1>
              <p className="text">{policy.content}</p>
            </div>
          ))}
      </div>
    </div>
  )
}

export default Policy
